import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function LimitTimeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 12, 12);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path d="M2.15 6C2.15 3.8737 3.8737 2.15 6 2.15M8.47495 3.525L5.99995 6M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6ZM6.55 6C6.55 6.30376 6.30376 6.55 6 6.55C5.69624 6.55 5.45 6.30376 5.45 6C5.45 5.69624 5.69624 5.45 6 5.45C6.30376 5.45 6.55 5.69624 6.55 6Z" stroke="#171717" strokeLinecap="round" strokeLinejoin="round" /></svg>
  );
}

export default LimitTimeIcon;
